<template>
<div id="etips" >

    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar eTips" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                       
                   
                        <v-btn small outlined color="primary" to="/catalogos/etipsHTML" title="Manual de Usuario" >
                            <v-icon>print</v-icon> Manual de Usuario

                        </v-btn>

                        
                        <v-dialog v-model="modal" width="900" height="600" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >
                                            {{
                                            update ? "edit" : "add"
                                            }}
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} eTip</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center >
                                            
                                            <v-text-field name="nombre" label="Nombre" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                            <v-layout row wrap>
                                                <v-flex s6 m6 l6>
                                                    <v-text-field name="titulo" label="Titulo" type="text" v-model="model.titulo" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s6 m6 l6>
                                                    <v-text-field name="subtitulo" label="Subtítulo" type="text" v-model="model.subtitulo" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-card-text>

                                                <base-material-tabs color="primary" :key="model.url" >
                                                    <v-tab key=1>Opcion 1 </v-tab>
                                                    <v-tab key=2>Opcion 2 </v-tab>
                                                    <v-tab key=3>Opcion 3 </v-tab>
                                                    <v-tab key=4>Preguntas Frecuentes </v-tab>
                                                    <v-tab-item key="t1" >
                                                        <v-card flat class="my-2" >
                                                            <v-card-text>
                                                                <v-layout row wrap>
                                                                    <v-flex s4 m4 l4> 
                                                                        <v-select
                                                                            :items="visible"
                                                                            v-model="model.tab1"
                                                                            label="Mostrar"
                                                                            ></v-select>
                                                                        </v-flex>
                                                                    <v-flex s8 m8 l8>
                                                                        <v-text-field label="Nombre del Botón" type="text" v-model="model.tab1_titulo" maxlength="100" ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <vue-editor id="t1" v-model="model.tab1_contenido" ></vue-editor>
                                                              
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item key="t2" >
                                                        <v-card flat class="my-2" >
                                                               <v-card-text>
                                                                <v-layout row wrap>
                                                                    <v-flex s4 m4 l4>
                                                                        <v-select
                                                                            :items="visible"
                                                                            v-model="model.tab2"
                                                                            label="Mostrar"
                                                                            ></v-select>
                                                                       
                                                                    </v-flex>
                                                                    <v-flex s8 m8 l8>
                                                                        <v-text-field label="Nombre del Botón" type="text" v-model="model.tab2_titulo" maxlength="100" ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <vue-editor id="t2" v-model="model.tab2_contenido" ></vue-editor>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item key="t3" >
                                                        <v-card flat class="my-2" >
                                                               <v-card-text>
                                                                <v-layout row wrap>
                                                                    <v-flex s4 m4 l4>
                                                                        <v-select
                                                                            :items="visible"
                                                                            v-model="model.tab3"
                                                                            label="Mostrar"
                                                                            ></v-select>
                                                                       
                                                                    </v-flex>
                                                                    <v-flex s8 m8 l8>
                                                                        <v-text-field label="Nombre del Botón" type="text" v-model="model.tab3_titulo" maxlength="100" ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                               <vue-editor id="t3" v-model="model.tab3_contenido" ></vue-editor>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                    <v-tab-item key="t4" >
                                                        <v-card flat class="my-2" >
                                                               <v-card-text>
                                                                <v-layout row wrap>
                                                                    <v-flex s4 m4 l4>
                                                                         <v-select
                                                                            :items="visible"
                                                                            v-model="model.tab4"
                                                                            label="Mostrar"
                                                                            ></v-select>
                                                                    </v-flex>
                                                                    <v-flex s8 m8 l8>
                                                                        <v-text-field label="Nombre del Botón" type="text" v-model="model.tab4_titulo" maxlength="100" ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                               <vue-editor id="t4" v-model="model.tab4_contenido" ></vue-editor>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-tab-item>
                                                </base-material-tabs>
                                            </v-card-text>

                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn @click.native="modal = false" >
                                            <v-icon>cancel</v-icon>Cancelar
                                        </v-btn>
                                        <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                            <v-icon>done</v-icon>
                                            {{ update ? "Actualizar" : "Guardar" }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>

                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="vuetable" :data="etips.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import { VueEditor, Quill } from "vue2-editor";


export default {
    components: {VueEditor},

    data: () => ({
        visible: [
          { text: 'SI', value:1 },
          { text: 'NO', value:0 },
        ],
        fab: false,
        URL: "",
        name: "datagrid",
        importData: [],
        columns: ["nombre", "modulo", "categoria", "actions"],
        show_loading: true,
        title_catalogo: "Administrar eTips",
        options: {
            filterable: [ "nombre", "modulo","categoria",],
            sortable: [ "nombre", "modulo","categoria",],

            headings: {
                nombre: "Nombre",
                modulo: "Módulo",
                categoria: "Categoría",
                actions: "Operaciones"
            }
        },
        columnDefs: null,
        rowData: null,
        show_loading: true,
        breadcrumbs: [{
                text: "Administración",
                disabled: false,
                to: "/admin"
            },
            {
                text: "eTips",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id: 0,
            nombre: "",
            url: "",
            titulo: "",
            subtitulo: "",
            tab1: "",
            tab1_titulo: "",
            tab1_contenido: "",
            tab2: "",
            tab2_titulo: "",
            tab2_contenido: "",
            tab3: "",
            tab3_titulo: "",
            tab3_contenido: "",
            tab4: "",
            tab4_titulo: "",
            tab4_contenido: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        etips: {
            selected: [],
            camposexcel: {
                Nombre: "nombre"
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                nombre: "nombre"
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                nombre: "[Nombre]"
            }]
        }
    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.etips.items;
            }
        }
    },
    methods: {
        openModal: function (type) {
            this.title = "Actualizar eTip";
            this.update = true;

            this.modal = true;
        },
    
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.view.editable.element.parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.view.editable.element
            );
        },
        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "put";
                var urlCliente =
                    this.URL + "configuracion/etips/" + this.model.id + "/";
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        console.log(res);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            axios
                .post(this.URL + "configuracion/etips/get_titulos/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                      
                        this.etips.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            axios
                .get(this.URL + "configuracion/etips/" + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                });
        } //getRegistro
    }, //methods
    created: function () {
        this.URL = this.$hostname;
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        this.cargar();
    }
};
</script>

<style scoped>
.document-editor {
    border: 1px solid !important;

    /* Set vertical boundaries for the document editor. */
    min-height: 150px;
    max-height: 450px;

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
}
</style>
